import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import withStyles from 'react-jss';
import { findKey, cloneDeep } from 'lodash';
import Loading from '../../utility/Loading';
import Checkmark from '../../utility/Checkmark';
import { tenantsModalCopy as copy } from '../../../copy/advisor-dashboard/tenants-tab.json';
import ComponentHeader from '../../ecap/ComponentHeader';
import ToggleButton from '../../utility/ToggleButton';
import DashboardButton from './DashboardButton';
import {
  labelAndFileSelector,
  labelAndInput,
  effectiveDateSection,
  checkButtonErrors,
  checkJobStatusInterval,
} from './modalUtil';
import {
  insertTenantTableData,
  uploadTenantPhotoToS3,
  insertTenantFeatures,
  insertFeaturesByName,
  insertCareerCategories,
  insertCareers,
  insertDegrees,
  insertHighSchools,
  insertGameImages,
  insertHighSchoolClasses,
  insertSubjectDifficultyMappings,
  insertDegreeSubjectDifficultyMappings,
  insertSkillsCourseRecommendations,
  checkJobStatus,
} from '../../../store/actions';
import ErrorMessage from '../../ErrorMessage';

const fileCustom = {
  backgroundColor: (props) => ({
    '&::before': {
      backgroundColor: props.tenant?.primary || '#000000',
      content: `'Select'`,
      border: `1px solid $`,
    },
  }),
  button: (props) => ({
    backgroundColor: 'white',
    color: props.tenant?.primary || '#000000',
    border: `1px solid ${props.tenant?.primary || '#000000'}`,

    '&:hover': {
      backgroundColor: props.tenant?.primary || '#000000',
      border: `2px solid ${props.tenant?.primary || '#000000'}`,
      color: 'white',
    },
    '&:disabled': {
      color: 'black',
      border: 'none',
      backgroundColor: '#e5e5e5',
      padding: ' 0 34px',
      cursor: 'not-allowed',
    },
  }),
};
export class CreateModal extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      name: '',
      logoLink: null,
      primary: '#000000',
      secondary: '#000000',
      logo: '',
      hero1: '',
      hero2: '',
      termsName: '',
      customGameImages: true,
      highSchoolFeatures: false,
      skillsCourseRecommendations: null,
      skillsCourseRecommendationsFeature: false,
      effectiveDateMonth: '',
      effectiveDateYear: '',
      careersData: null,
      careerCategoriesData: null,
      degreesData: null,
      schoolsCsv: null,
      gameImageCsv: null,
      csvErrorMessage: '',
      unauthorizedMessage: '',
      loading: false,
      loadingMessage: '',
      errors: {
        name: false,
        primary: false,
        secondary: false,
        logoLink: false,
        buttons: false,
        csv: false,
        unauthorized: false,
      },
      highSchoolClasses: null,
      subjectDifficultyMapping: null,
      degreeSubjectDifficultyMapping: null,
      showDashButtonSection: {
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        6: false,
      },
      dashButtons: [
        { button1: [] },
        { button2: [] },
        { button3: [] },
        { button4: [] },
        { button5: [] },
        { button6: [] },
      ],
    };
  }

  errorMessages = {
    name: 'Required field. Must contain only alphanumeric characters.',
    logoLink: 'Must contain http:// or https:// prefix.',
    primary: 'Must be a valid 6-digit hex code.',
    secondary: 'Must be a valid 6-digit hex code.',
    buttons:
      'All buttons must have a label and redirect URL. All redirect URLs must contain http:// or https:// prefix.',
    termsName: 'Required field.',
    effectiveDateMonth: 'Required field',
    effectiveDateYear: 'Required field',
  };

  colorPrimary = {
    color: `${this.props.tenant?.primary || '#000000'}`,
  };

  buttonContainerStyle = {
    backgroundColor: `${this.props.tenant?.primary || '#000000'}`,
    border: `1px solid ${this.props.tenant?.primary || '#000000'}`,
  };

  disabledButtonContainerStyle = {
    backgroundColor: 'white',
    border: `1px solid #E0E0E0`,
    cursor: 'not-allowed',
  };

  addDashButton = {
    backgroundColor: `${this.props.tenant?.primary || '#000000'}`,
    padding: '0 2em',
  };

  updateValue = (stateVal, oldVal) => {
    this.setState({
      [stateVal]: !oldVal,
    });
  };

  basicInfoSection = () => {
    return (
      <div className="tenant-modal__basic-info">
        <div className="tenant-modal__row">
          {labelAndInput(
            'name',
            copy.name,
            'tenant-modal__fill-space tenant-modal__margin-bottom',
            this.state.name,
            this.handleInputChange,
            this.errorMessages.name,
            this.state.errors.name
          )}
        </div>
        <div className="tenant-modal__row tenant-modal__margin-bottom">
          {labelAndInput(
            'logoLink',
            copy.logoLink,
            'tenant-modal__fill-space',
            this.state.logoLink,
            this.handleInputChange,
            this.errorMessages.logoLink,
            this.state.errors.logoLink
          )}
        </div>
        <div className="tenant-modal__column tenant-modal__margin-bottom">
          {labelAndFileSelector(
            copy.logo,
            copy.logoSubText,
            'logo',
            this.setFile,
            this.state.logo,
            this.props.classes.backgroundColor
          )}
        </div>
        <div className="tenant-modal__hr" />
      </div>
    );
  };

  colorAndHeroesSection = () => {
    return (
      <div className="tenant-modal__color-and-heroes">
        <div className="tenant-modal__row tenant-modal__margin-bottom">
          {labelAndInput(
            'primary',
            copy.primary,
            'tenant-modal__leave-room',
            this.state.primary,
            this.handleInputChange,
            this.errorMessages.primary,
            this.state.errors.primary
          )}
          {labelAndInput(
            'secondary',
            copy.secondary,
            'tenant-modal__leave-room',
            this.state.secondary,
            this.handleInputChange,
            this.errorMessages.secondary,
            this.state.errors.secondary
          )}
        </div>
        <div className="tenant-modal__column tenant-modal__margin-bottom">
          {labelAndFileSelector(
            copy.hero1,
            copy.hero1SubText,
            'hero1',
            this.setFile,
            this.state.hero1,
            this.props.classes.backgroundColor
          )}
        </div>
        <div className="tenant-modal__column tenant-modal__margin-bottom">
          {labelAndFileSelector(
            copy.hero2,
            copy.hero2SubText,
            'hero2',
            this.setFile,
            this.state.hero2,
            this.props.classes.backgroundColor
          )}
        </div>
        <div className="tenant-modal__hr" />
      </div>
    );
  };

  headerAndToggle = (header, stateVal, ariaLabel, displayToggle = true) => {
    return (
      <div className="tenant-modal__header-and-toggle tenant-modal__margin-bottom">
        <h2 className="tenant-modal__h2">{header}</h2>
        {displayToggle && (
          <ToggleButton
            className={classNames({
              'toggle-button-modality': true,
            })}
            value={this.state[stateVal]}
            color="white"
            onClick={() => {
              this.updateValue(stateVal, this.state[stateVal]);
            }}
            backgroundStyle={
              this.state[stateVal]
                ? this.buttonContainerStyle
                : this.disabledButtonContainerStyle
            }
            buttonContainerStyle="toggle-button"
            ariaLabel={ariaLabel}
            showLabel
            classRec
          />
        )}
      </div>
    );
  };

  highSchoolFeaturesSection = () => {
    return (
      <div className="tenant-modal__custom-game-images">
        {this.headerAndToggle(
          copy.highSchoolFeaturesHeader,
          'highSchoolFeatures',
          'Turn on to insert data for high school features. Turn off to forego high school features.'
        )}
        {this.state.highSchoolFeatures && (
          <>
            <div className="tenant-modal__column tenant-modal__margin-bottom">
              {labelAndFileSelector(
                copy.highSchoolClasses,
                copy.dataRequiredSubtext,
                'highSchoolClasses',
                this.setFile,
                this.state.highSchoolClasses,
                this.props.classes.backgroundColor
              )}
            </div>
            <div className="tenant-modal__column tenant-modal__margin-bottom">
              {labelAndFileSelector(
                copy.subjectDifficultyMapping,
                copy.dataRequiredSubtext,
                'subjectDifficultyMapping',
                this.setFile,
                this.state.subjectDifficultyMapping,
                this.props.classes.backgroundColor
              )}
            </div>
            <div className="tenant-modal__column tenant-modal__margin-bottom">
              {labelAndFileSelector(
                copy.degreeSubjectDifficultyMapping,
                copy.dataRequiredSubtext,
                'degreeSubjectDifficultyMapping',
                this.setFile,
                this.state.degreeSubjectDifficultyMapping,
                this.props.classes.backgroundColor
              )}
            </div>
          </>
        )}
        <div className="tenant-modal__hr" />
      </div>
    );
  };

  handleInputChange = (id, value) => {
    let stateVal = value;
    if ((id === 'secondary' || id === 'primary') && !value.startsWith('#')) {
      stateVal = `#${value}`;
    }
    this.setState({
      [id]: stateVal,
    });
  };

  insertCategoriesCareersAndDegrees = async (tenantId) => {
    const {
      careerCategoriesData,
      careersData,
      degreesData,
      skillsCourseRecommendations,
      skillsCourseRecommendationsFeature,
      highSchoolClasses,
      subjectDifficultyMapping,
      degreeSubjectDifficultyMapping,
    } = this.state;
    try {
      let response = await this.props.insertCareerCategories(
        tenantId,
        careerCategoriesData
      );
      if (response?.status !== 200) return response.data;
      response = await this.props.insertCareers(tenantId, careersData);
      if (response?.status !== 200) {
        return response.data;
      }
      const jobIdentifier = `${this.state.name}_${new Date()
        .toISOString()
        .slice(0, 19)
        .replace(/-/g, '')}`;
      response = await this.props.insertDegrees(
        tenantId,
        degreesData,
        jobIdentifier
      );

      /*
      In the case of 500 or 401 responses, we know the degree insertion failed.
      Otherwise, AWS may have timed out while the insertion is still in progress.
      We must poll the server via checkJobStatus() to determine the actual result.
      */
      if (response?.status === 500 || response?.status === 401) {
        return response.data;
      }

      const jobStatus = await checkJobStatusInterval(
        jobIdentifier,
        this.props.checkJobStatus
      );
      if (jobStatus.status !== 'SUCCESS') {
        throw new Error(
          `Something went wrong with degrees. Status: '${jobStatus.error_message}'`
        );
      }
      if (
        highSchoolClasses &&
        subjectDifficultyMapping &&
        degreeSubjectDifficultyMapping
      ) {
        response = await this.props.insertHighSchoolClasses(
          tenantId,
          highSchoolClasses
        );
        if (response?.status !== 200) return response.data;
        response = await this.props.insertSubjectDifficultyMappings(
          tenantId,
          subjectDifficultyMapping
        );
        if (response?.status !== 200) return response.data;
        response = await this.props.insertDegreeSubjectDifficultyMappings(
          tenantId,
          degreeSubjectDifficultyMapping
        );
        if (response?.status !== 200) return response.data;
      }

      if (skillsCourseRecommendationsFeature && skillsCourseRecommendations) {
        response = await this.props.insertSkillsCourseRecommendations(
          tenantId,
          skillsCourseRecommendations
        );
        if (response?.status !== 200) return response.data;
      }
    } catch (e) {
      return new Error(e);
    }
  };

  insertSchoolsAndGameImages = async (tenantId) => {
    const { schoolsCsv, gameImageCsv } = this.state;
    try {
      let response = await this.props.insertHighSchools(tenantId, schoolsCsv);
      if (response?.status !== 200) return response.data;
      response = await this.props.insertGameImages(tenantId, gameImageCsv);
      if (response?.status !== 200) return response.data;
    } catch (e) {
      return new Error(e);
    }
  };

  checkForErrors = async () => {
    const buttonErrors = await checkButtonErrors(this.state.dashButtons);
    const {
      errors,
      name,
      logoLink,
      primary,
      secondary,
      termsName,
      effectiveDateMonth,
      effectiveDateYear,
    } = this.state;
    const errorsClone = cloneDeep(errors);
    errorsClone.buttons = buttonErrors;
    const hexColor = /^#[0-9A-F]{6}$/i;
    errorsClone.primary = !primary.match(hexColor);
    errorsClone.effectiveDateMonth = !effectiveDateMonth;
    errorsClone.effectiveDateYear = !effectiveDateYear;
    errorsClone.secondary = !secondary.match(hexColor);
    errorsClone.logoLink = !!(
      !!logoLink &&
      logoLink.length > 0 &&
      !logoLink.includes('http://') &&
      !logoLink.includes('https://')
    );
    errorsClone.name = !!(
      !name ||
      name.length === 0 ||
      name.match(/^[0-9A-Za-z]+$/) === null
    );
    errorsClone.termsName = !!(!termsName || termsName.length === 0);
    this.setState(() => ({
      errors: errorsClone,
    }));
    return Object.values(errorsClone).find((x) => !!x) !== undefined;
  };

  createTenant = async () => {
    this.setState((prevState) => ({
      errors: {
        ...prevState.errors,
        csv: false,
        unauthorized: '',
      },
      csvErrorMessage: '',
      loading: true,
      loadingMessage: 'Checking for errors...',
    }));
    const {
      name,
      primary,
      secondary,
      termsName,
      dashButtons,
      highSchoolClasses,
      subjectDifficultyMapping,
      degreeSubjectDifficultyMapping,
      skillsCourseRecommendations,
      logoLink,
      effectiveDateMonth,
      effectiveDateYear,
    } = this.state;

    const filtered = [];
    dashButtons.map((stateObj) => {
      Object.values(stateObj).map((buttonArray) => {
        if (buttonArray.length > 0) filtered.push(...buttonArray);
      });
    });

    const errorsPresent = await this.checkForErrors();
    if (errorsPresent) {
      this.setState({ loading: false });
      return;
    }
    const features = ['basic'];
    if (
      highSchoolClasses &&
      subjectDifficultyMapping &&
      degreeSubjectDifficultyMapping
    ) {
      features.push('highschool');
    }
    if (skillsCourseRecommendations) {
      features.push('skills_course_recommendations');
    }
    try {
      this.updateLoadingMessage('Uploading images...');
      const logo = await this.props.uploadTenantPhotoToS3(
        this.state.logo,
        'logo'
      );
      const hero = await this.props.uploadTenantPhotoToS3(
        this.state.hero1,
        'hero'
      );
      const dashboardHero = await this.props.uploadTenantPhotoToS3(
        this.state.hero2,
        'dashboard-hero'
      );

      const body = {
        name,
        primary_color: primary,
        secondary_color: secondary,
        dashboard_hero: dashboardHero,
        hero,
        logo,
        logo_link: logoLink,
        buttons: filtered,
        terms_info: {
          name: termsName,
          effective_date_month: effectiveDateMonth.value,
          effective_date_year: effectiveDateYear,
        },
      };

      this.updateLoadingMessage('Creating tenant...');
      const tenantId = await this.props.insertTenantTableData(body);
      this.updateLoadingMessage('Inserting tenant data...');
      const funcs = [
        this.insertCategoriesCareersAndDegrees,
        this.insertSchoolsAndGameImages,
      ];

      return Promise.all(funcs.map(async (func) => func(tenantId))).then(
        async (resp) => {
          const responseErrors = resp.filter((x) => x !== undefined);
          if (responseErrors.length > 0) {
            this.updateLoadingMessage(responseErrors.join('\n'));
          } else {
            await this.props.insertFeaturesByName(tenantId, features);
            this.updateLoadingMessage('Tenant created successfully!');
            this.setState({
              loading: false,
            });
            await this.props.refreshTenants();
          }
        }
      );
    } catch (e) {
      this.setState({
        csvErrorMessage: e,
        loading: false,
      });
      return e;
    }
  };

  updateLoadingMessage = (msg) => {
    this.setState({
      loadingMessage: msg,
    });
  };

  setFile = (e) => {
    this.setState({
      [e.target.id]: e.target.files[0],
    });
  };

  termsSection = () => {
    return (
      <div className="tenant-modal__terms-section">
        <div className="tenant-modal__row tenant-modal__margin-bottom">
          {labelAndInput(
            'termsName',
            copy.termsName,
            'tenant-modal__leave-room',
            this.state.termsName,
            this.handleInputChange,
            this.errorMessages.termsName,
            this.state.errors.termsName
          )}
        </div>
        {effectiveDateSection(
          this.state.effectiveDateMonth,
          this.handleMonthChange,
          this.errorMessages.effectiveDateMonth,
          this.state.errors.effectiveDateMonth,
          this.state.effectiveDateYear,
          this.handleYearChange,
          this.errorMessages.effectiveDateYear,
          this.state.errors.effectiveDateYear
        )}
        <div className="tenant-modal__hr" />
      </div>
    );
  };

  handleYearChange = (e) => {
    const filtered = e.target.value.replace(/[^0-9]/g, '');
    this.setState({
      effectiveDateYear: filtered,
    });
  };

  handleMonthChange = (e) => {
    this.setState({
      effectiveDateMonth: e,
    });
  };

  handleAddDashButton = () => {
    const { showDashButtonSection } = this.state;
    const result = findKey(showDashButtonSection, (x) => {
      return !x;
    });
    if (result !== undefined) {
      this.setState({
        showDashButtonSection: {
          ...showDashButtonSection,
          [result]: true,
        },
      });
    }
  };

  updateDashButton = (num, id, value, isDropdown, subButtons, buttonLabel) => {
    const clone = cloneDeep(this.state.dashButtons);
    if (!isDropdown) {
      if (clone[num - 1][`button${num}`][0]) {
        clone[num - 1][`button${num}`][0][id] = value;
      } else {
        clone[num - 1][`button${num}`] = [
          {
            [id]: value,
            isDropdown: false,
            buttonNumber: num,
            order: 1,
          },
        ];
      }
    }
    if (isDropdown) {
      clone[num - 1][`button${num}`] = [
        {
          label: buttonLabel,
          isDropdown: true,
          buttonNumber: num,
          order: 1,
        },
        ...subButtons,
      ];
    }
    this.setState(() => ({
      dashButtons: clone,
    }));
  };

  dashboardButtons = () => {
    const { showDashButtonSection, dashButtons } = this.state;
    return (
      <div className="tenant-modal__dashboard-buttons-section">
        {Object.keys(showDashButtonSection).map((num) => {
          if (showDashButtonSection[num])
            return (
              <DashboardButton
                colorPrimary={this.colorPrimary}
                checkboxAndLabel={this.checkboxAndLabel}
                num={num}
                key={num}
                button={dashButtons[num - 1][`button${num}`]}
                updateButtonOnParent={this.updateDashButton}
              />
            );
        })}
        {findKey(showDashButtonSection, (x) => {
          return !x;
        }) !== undefined && (
          <div className="tenant-modal__add-button-container">
            <button
              tabIndex={0}
              type="button"
              onClick={() => this.handleAddDashButton()}
              onKeyDown={(e) => {
                if (['Enter'].includes(e.key)) {
                  this.handleAddDashButton();
                }
              }}
              className="button--primary tenant-modal__add-dash-button tenant-modal__margin-bottom"
              style={this.addDashButton}
            >
              {copy.addDashButton}
            </button>
          </div>
        )}
        <ErrorMessage
          error={this.errorMessages.buttons}
          hidden={!this.state.errors.buttons}
        />
        <div className="tenant-modal__hr" />
      </div>
    );
  };

  tenantDataUploadSection = () => {
    return (
      <div>
        <h2 className="tenant-modal__tenant-data-h2">
          {copy.tenantDataHeader}
        </h2>
        <div className="tenant-modal__column tenant-modal__margin-bottom">
          {labelAndFileSelector(
            copy.careerCategories,
            copy.dataRequiredSubtext,
            'careerCategoriesData',
            this.setFile,
            this.state.careerCategoriesData,
            this.props.classes.backgroundColor
          )}
        </div>
        <div className="tenant-modal__column tenant-modal__margin-bottom">
          {labelAndFileSelector(
            copy.careersData,
            copy.dataRequiredSubtext,
            'careersData',
            this.setFile,
            this.state.careersData,
            this.props.classes.backgroundColor
          )}
        </div>
        <div className="tenant-modal__column tenant-modal__margin-bottom">
          {labelAndFileSelector(
            copy.careerDegreesPairings,
            copy.dataRequiredSubtext,
            'degreesData',
            this.setFile,
            this.state.degreesData,
            this.props.classes.backgroundColor
          )}
        </div>
        <div className="tenant-modal__column tenant-modal__margin-bottom">
          {labelAndFileSelector(
            copy.highSchools,
            copy.dataRequiredSubtext,
            'schoolsCsv',
            this.setFile,
            this.state.schoolsCsv,
            this.props.classes.backgroundColor
          )}
        </div>
        <div className="tenant-modal__column tenant-modal__margin-bottom">
          {labelAndFileSelector(
            copy.gameImages,
            copy.dataRequiredSubtext,
            'gameImageCsv',
            this.setFile,
            this.state.gameImageCsv,
            this.props.classes.backgroundColor
          )}
        </div>
        <div className="tenant-modal__hr tenant-modal__margin-bottom" />
      </div>
    );
  };

  skillsCourseRecommendationsSection = () => {
    return (
      <div>
        {this.headerAndToggle(
          copy.skillsCourseRecsHeader,
          'skillsCourseRecommendationsFeature',
          'Turn on to add skills course recommendations data. Turn off to forego skills course recommendations feature.'
        )}
        {this.state.skillsCourseRecommendationsFeature && (
          <div className="tenant-modal__column tenant-modal__margin-bottom">
            {labelAndFileSelector(
              copy.skillsData,
              copy.dataRequiredSubtext,
              'skillsCourseRecommendations',
              this.setFile,
              this.state.skillsCourseRecommendations,
              this.props.classes.backgroundColor
            )}
          </div>
        )}
      </div>
    );
  };

  isButtonDisabled = () => {
    const {
      name,
      primary,
      secondary,
      logo,
      termsName,
      effectiveDateMonth,
      effectiveDateYear,
      hero1,
      hero2,
      careersData,
      careerCategoriesData,
      degreesData,
      schoolsCsv,
      gameImageCsv,
      highSchoolClasses,
      subjectDifficultyMapping,
      degreeSubjectDifficultyMapping,
      highSchoolFeatures,
      skillsCourseRecommendations,
      skillsCourseRecommendationsFeature,
    } = this.state;
    return (
      !name ||
      (primary.length !== 4 && primary.length !== 7) ||
      (secondary.length !== 4 && secondary.length !== 7) ||
      !logo ||
      !termsName ||
      !hero1 ||
      !hero2 ||
      !careersData ||
      !careerCategoriesData ||
      !degreesData ||
      !schoolsCsv ||
      !gameImageCsv ||
      (highSchoolFeatures &&
        (!highSchoolClasses ||
          !subjectDifficultyMapping ||
          !degreeSubjectDifficultyMapping)) ||
      (skillsCourseRecommendationsFeature && !skillsCourseRecommendations) ||
      !effectiveDateMonth ||
      !effectiveDateYear
    );
  };

  saveButton = () => {
    return (
      <div className="tenant-modal__center">
        <button
          className={classNames(
            'button--primary',
            'tenant-modal__save-button',
            this.props.classes.button
          )}
          style={
            this.isButtonDisabled() ? this.disabledButtonContainerStyle : null
          }
          disabled={this.isButtonDisabled()}
          type="button"
          onClick={async () => {
            await this.createTenant();
          }}
        >
          {copy.saveButton}
        </button>
        <br />
      </div>
    );
  };

  displayLoadingContent = () => {
    return (
      <div className="tenant-modal__loading-container">
        {this.state.loading ? (
          <Loading width="100%" />
        ) : (
          <div className="tenant-modal__success-container">
            <Checkmark color="green" />
          </div>
        )}
        <p className="tenant-modal__loading-message">
          {this.state.loadingMessage}
        </p>
      </div>
    );
  };

  render() {
    const { tenant, modalType } = this.props;
    const { csvErrorMessage, unauthorizedMessage } = this.state;
    let componentHeaderTenant = tenant;
    if (tenant === undefined) {
      componentHeaderTenant = {
        primary: this.state.primary,
        secondary: this.state.secondary,
      };
    }
    return (
      <>
        {this.state.loading ||
        this.state.loadingMessage === 'Tenant created successfully!' ? (
          this.displayLoadingContent()
        ) : (
          <>
            <ComponentHeader
              headerText={copy.create}
              tenant={componentHeaderTenant}
              marginTop="0px"
            />
            {this.basicInfoSection()}
            {this.colorAndHeroesSection()}
            {this.highSchoolFeaturesSection()}
            {this.termsSection()}
            {this.dashboardButtons()}
            {this.tenantDataUploadSection()}
            {this.skillsCourseRecommendationsSection()}
            {this.saveButton()}
            {this.state.errors.csv && (
              <ErrorMessage
                error={csvErrorMessage}
                hidden={!this.state.errors.csv}
              />
            )}
            {this.state.errors.unauthorized && (
              <ErrorMessage
                error={unauthorizedMessage}
                hidden={!this.state.errors.unauthorized}
              />
            )}
          </>
        )}
      </>
    );
  }
}

export default connect(null, {
  uploadTenantPhotoToS3,
  insertTenantTableData,
  insertTenantFeatures,
  insertFeaturesByName,
  insertCareerCategories,
  insertCareers,
  insertDegrees,
  insertHighSchools,
  insertGameImages,
  insertHighSchoolClasses,
  insertSubjectDifficultyMappings,
  insertDegreeSubjectDifficultyMappings,
  insertSkillsCourseRecommendations,
  checkJobStatus,
})(withStyles(fileCustom)(CreateModal));
